
import Vue from 'vue';
import { IState } from '../store/state';
import { search } from '../store/actions'

interface ISearchFieldData {
  query: string;
}

interface ISearchFieldComputed {
  getQuery: string;
  initialNumberToShow: number;
}

interface ISearchFieldMethods {
  search(): void;
  setQuery(query: string): void
}

export default Vue.extend<ISearchFieldData ,ISearchFieldMethods ,ISearchFieldComputed ,{} >({
	name: 'SearchField',

  data() {
    return { 
      query: '',
    }
  },

  computed: {
    initialNumberToShow() {
      return (this.$store.state as IState).initialNumberToShow;
    },
    getQuery() {
      return this.$store.getters.query;
    },
  },

  methods: {
    setQuery(query: string) {
      this.$store.commit({
        type: 'setQuery',
        payload: query,
      })
    },
    search() {
      this.$store.commit({
        type: 'setNumberToShow',
        payload: this.initialNumberToShow,
      })
      this.$store.dispatch(search(''));
    },
  },

  mounted() {
    if(this.getQuery && this.getQuery !== ""){
      this.query = this.getQuery;
      this.$store.dispatch(search(''));
    }
  }
})
